// extracted by mini-css-extract-plugin
export default {"headerContainer":"style_headerContainer__0Basu","logo":"style_logo__R7iiN"};